/**
 * Centralized table name constants for all Supabase database operations.
 * Use these instead of hardcoded string literals to prevent typos.
 */
export const TABLES = {
  YOINKS: 'yoinks',
  LOCATIONS: 'locations',
  CATEGORIES: 'categories',
  PROFILES: 'profiles',
  PUBLIC_PROFILES: 'public_profiles',
  USER_CATEGORY_FOLLOWS: 'user_category_follows',
  USER_FOLLOWS: 'user_follows',
  LISTS: 'lists',
  LIST_ENTRIES: 'list_entries',
  LIST_FOLLOWS: 'list_follows',
  PERSONAL_CATEGORIES: 'personal_categories',
  USER_AWARDS: 'user_awards',
  USER_COLLECTION_STORIES: 'user_collection_stories',
  APP_SETTINGS: 'app_settings',
  LOGIN_HISTORY: 'login_history',
  ANALYTICS_EVENTS: 'analytics_events',
  MARKETING_PROSPECTS: 'marketing_prospects',
  FEEDBACK: 'feedback',
};
